import React, { useState } from 'react';
import { EnforcementReference } from '../utils/types';

interface EnforcementRefBlockProps {
  refs: EnforcementReference[];
}

/**
 * Collapsible block showing enforcement actions that clarify a compliance check.
 * Collapses by default to keep the UI compact.
 */
export default function EnforcementRefBlock({ refs }: EnforcementRefBlockProps) {
  const [open, setOpen] = useState(false);

  if (!refs || refs.length === 0) return null;

  return (
    <div className="enforcement-ref-block">
      <button
        className="enforcement-ref-block__toggle"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span
          style={{
            display: 'inline-block',
            transition: 'transform 0.15s',
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
            fontSize: '12px',
            marginRight: '5px',
          }}
        >
          ▶
        </span>
        Enforcement precedent ({refs.length} case{refs.length !== 1 ? 's' : ''})
      </button>

      {open && (
        <div className="enforcement-ref-block__list">
          {refs.map((ref) => (
            <div key={`${ref.case}-${ref.year}`} className="enforcement-ref-block__item">
              <div className="enforcement-ref-block__header">
                <span className="enforcement-ref-block__case">
                  {ref.url ? (
                    <a
                      href={ref.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="enforcement-ref-block__link"
                    >
                      {ref.case} ({ref.year})
                    </a>
                  ) : (
                    <>
                      {ref.case} ({ref.year})
                    </>
                  )}
                </span>
                {ref.penalty && (
                  <span className="enforcement-ref-block__penalty">{ref.penalty}</span>
                )}
              </div>
              <p className="enforcement-ref-block__relevance">{ref.relevance}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
